export default __webpack_public_path__ + "static/media/h-banner.d446ec41.png";